import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import {
    ACT_TYPE_LIST, ACT_TYPE_ADD, ACT_TYPE_GET, ACT_TYPE_EDIT
} from "../actions";
import {
    TypeActListSuccess, TypeActListError,
    TypeActAddSuccess, TypeActAddError,
    TypeActGetSuccess, TypeActGetError,
    TypeActEditSuccess, TypeActEditError
} from '../actions';

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => { unsubscribe(); resolve(token); });
        }, reject);
    });
}

const fetchApi = async (endpoint, payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + endpoint, {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(r => r.json()).then(d => d).catch(err => console.log(err));
    return { "data": response };
};

export function* watchTypeActList() { yield takeEvery(ACT_TYPE_LIST, onTypeActList); }
export function* watchTypeActAdd() { yield takeLatest(ACT_TYPE_ADD, onTypeActAdd); }
export function* watchTypeActGet() { yield takeLatest(ACT_TYPE_GET, onTypeActGet); }
export function* watchTypeActEdit() { yield takeLatest(ACT_TYPE_EDIT, onTypeActEdit); }

function* onTypeActList(data) {
    try {
        const r = yield call(fetchApi, 'taskType/list', data.payload);
        yield put(TypeActListSuccess(r.data));
    } catch (e) { yield put(TypeActListError(e)); }
}

function* onTypeActAdd(data) {
    try {
        const r = yield call(fetchApi, 'taskType/add', data.payload);
        if (r.data.status === true) {
            NotificationManager.success(r.data.message, 'Éxito', 3000, null, null, '');
        } else {
            NotificationManager.error(r.data.message, 'Error', 3000, null, null, '');
        }
        yield put(TypeActAddSuccess(r.data));
    } catch (e) {
        yield put(TypeActAddError(e));
        NotificationManager.error('Error al crear tipo de actividad', 'Error', 3000, null, null, '');
    }
}

function* onTypeActGet(data) {
    try {
        const r = yield call(fetchApi, 'taskType/detail', data.payload);
        if (r.data && r.data.data) {
            yield put(TypeActGetSuccess(r.data.data));
        } else {
            yield put(TypeActGetError('No data'));
        }
    } catch (e) { yield put(TypeActGetError(e)); }
}

function* onTypeActEdit(data) {
    try {
        const r = yield call(fetchApi, 'taskType/edit', data.payload);
        if (r.data.status === true) {
            NotificationManager.success(r.data.message, 'Éxito', 3000, null, null, '');
        } else {
            NotificationManager.error(r.data.message, 'Error', 3000, null, null, '');
        }
        yield put(TypeActEditSuccess(r.data));
    } catch (e) {
        yield put(TypeActEditError(e));
        NotificationManager.error('Error al actualizar tipo de actividad', 'Error', 3000, null, null, '');
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchTypeActList),
        fork(watchTypeActAdd),
        fork(watchTypeActGet),
        fork(watchTypeActEdit)
    ]);
}
